module.exports = __webpack_public_path__ + "static/kalina_tyrkiel-6074da23ffcfefb5265cc12e0336ba27.jpg";